import React, { Component } from 'react';
import { connect } from 'react-redux';

import Barrier from '@object-generators/safety-barrier/objects/barrier';
import ButtonList from './ButtonList';
import MaterialSelector from '../../../../components/MaterialSelector/index';

import './styles.scss';
import { setObjectType } from '@reducers/options/actions';
import { setGroundOptions } from '@reducers/options/ground/actions';
import {
  disablePanelEdgeDistance,
  setPanelDPL,
  setPanelDPP,
  setPanelLYH,
  setPanelPosition,
  setPanelType
} from '@reducers/options/panel/actions';
import { setScrewOptions, setSquareScrews, setTriangleScrews } from '@reducers/options/screw/actions';
import {
  setActiveType, setActiveSubtype, setActivePlate,
  setProfileMaterial, setProfileFamily, setProfileSize,
  setManufacturer, setPredefinedBasePlate, setDesignation, setCladding
} from '@reducers/selectors/application/actions';
import { PerspectiveCameraTypes, setAxisOrientation, setPerspectiveCamera, setPerspectiveCameraType } from '@reducers/camera/actions';
import { appConfig, APP_TYPES, BRAND } from '@config';
import { APP_TEXTS } from '../../../../texts/texts';
import { ScrewGroup } from '@scene/objects/screw';
import Scene from '@scene';
import { CladdingTypes } from '@object-generators/safety-barrier/objects/cladding';
import { SafetyBarrierObject } from '@object-generators/safety-barrier';
import { getSBPredefinedBPs } from '@reducers/web-services/application/actions';
import Spinner from '@components/LoadingStyles/Spinner';
import { brandList } from '@src/app.values';
import { EventManager, EVENTS } from '@components/Events/events';

class SafetyBarrier extends Component {

  constructor(props){
    super(props);
    
    this.onTabSwitched = this.onTabSwitched.bind(this);
  }

  componentWillUnmount() {
    EventManager.removeListener(EVENTS.TAB_SWITCHED, this.onTabSwitched);
  }

  componentDidMount() {
    if (!this.props.selectedType)
      this.props.onSelectType(this.props.buttonsOptions[0]);
      
    EventManager.addListener(EVENTS.TAB_SWITCHED, this.onTabSwitched);
  }

  onTabSwitched() {
    if (this.props.predefinedBasePlate && this.props.predefinedBasePlate.isPredefinedBasePlate) {
      if (this.props.predefinedBasePlate.selectedManufacturer === '' || this.props.predefinedBasePlate.selectedDesignationId === '') {
        this.props.setPredefinedBasePlate(false);
      }
    }
  }

  render() {
    return (
      <div className="calculation safety-barrier">
        <section className="list-type">
          <section>
            <h4>{APP_TEXTS.TYPE_LABEL.Content} </h4>

            <ButtonList
              arr={this.props.buttonsOptions}
              onClick={this.props.onSelectType}
              selectedId={this.props.selectedType && this.props.selectedType.id}
            />

            <hr />

            {this.props.selectedType &&
              <ButtonList
                arr={this.props.selectedType.subtypes}
                onClick={this.props.onSelectSubtype}
                selectedId={this.props.selectedSubtype && this.props.selectedSubtype.id}
              />
            }
          </section>

          <hr />

          {this.props.selectedType &&
          (this.props.selectedType.id === SafetyBarrierObject.types.EDGE_SLAB || 
          this.props.selectedType.id === SafetyBarrierObject.types.FLOOR_SLAB || 
          this.props.selectedType.id === SafetyBarrierObject.types.BETWEEN_WALLS ||
          this.props.selectedType.id === SafetyBarrierObject.types.PEDESTAL) && (
            <React.Fragment>
              <section>
                <h4>{APP_TEXTS.SAFETY_BARRIER_CLADDING.Content}</h4>

                <select
                  id="cladding"
                  className="form-control w-25 mr-2 mb-2 ml-0"
                  onChange={(e) => this.props.setCladdingType(e.target.value)}
                  value={this.props.cladding}
                >
                  <option value={CladdingTypes.None} key={CladdingTypes.None}>
                    {APP_TEXTS.SAFETY_BARRIER_CLADDING_NONE.Content}
                  </option>
                  <option value={CladdingTypes.Glass} key={CladdingTypes.Glass}>
                    {APP_TEXTS.SAFETY_BARRIER_CLADDING_GLASS.Content}
                  </option>
                  <option value={CladdingTypes.Metallic} key={CladdingTypes.Metallic}>
                    {APP_TEXTS.SAFETY_BARRIER_CLADDING_METALLIC.Content}
                  </option>
                </select>
              </section>
              <hr />
            </React.Fragment>
          )}

          {this.props.selectedSubtype && (
            <section>
              <h4>{APP_TEXTS.SAFETY_BARRIER_BASE_PLATE_LABEL.Content} </h4>

              <ButtonList
                arr={this.props.selectedSubtype.plate}
                selectedId={this.props.selectedPlate && this.props.selectedPlate.id}
                onClick={this.props.onSelectBaseplate}
              />

              {BRAND === brandList.Spit && this.props.predefinedBasePlate && (
                <section className="list-type predefined-baseplate">
                  {this.props.isWaitingPredefinedBP && (<Spinner />)}
                  <div className='options-container'>
                    <label htmlFor="predefinedBasePlate">
                      <input
                        id="predefinedBasePlate"
                        type="checkbox"
                        className="m-2"
                        onChange={e => this.props.setPredefinedBasePlate(e.target.checked)}
                        checked={this.props.predefinedBasePlate.isPredefinedBasePlate}
                        disabled={!this.props.manufacturers || this.props.manufacturers.length <= 0}
                      />
                      <span className='font-weight-bold'>{APP_TEXTS.SAFETY_BARRIER_PREDEFINED_BASE_PLATE.Content}</span>
                    </label>
                    <select
                      name="manufacturers"
                      className="form-control d-block m-2"
                      value={this.props.predefinedBasePlate.selectedManufacturer}
                      onChange={e => this.props.onSelectManufacturer(e.target.value)}
                      disabled={!this.props.predefinedBasePlate.isPredefinedBasePlate || 
                        !this.props.manufacturers || this.props.manufacturers.length <= 0}
                    >
                      <option value="" disabled>{APP_TEXTS.SAFETY_BARRIER_MANUFACTURER.Content}</option>
                      {this.props.manufacturers && this.props.manufacturers.map(m => (
                        <option value={m} key={m}>{m}</option>
                      ))}
                    </select>
                    <select
                      name="designations"
                      className="form-control d-block m-2"
                      value={this.props.predefinedBasePlate.selectedDesignationId}
                      onChange={e => this.props.onSelectDesignation(e.target.value)}
                      disabled={!this.props.predefinedBasePlate.isPredefinedBasePlate || 
                        !this.props.manufacturers || this.props.manufacturers.length <= 0 || 
                        !this.props.designations[this.props.predefinedBasePlate.selectedManufacturer] || 
                        this.props.designations[this.props.predefinedBasePlate.selectedManufacturer].length <= 0}
                    >
                      <option value="" disabled>{APP_TEXTS.SAFETY_BARRIER_DESIGNATION.Content}</option>
                      {this.props.designations && this.props.designations[this.props.predefinedBasePlate.selectedManufacturer] &&
                        this.props.designations[this.props.predefinedBasePlate.selectedManufacturer].map(d => (
                          <option value={d.id} key={d.designation}>{d.designation}</option>
                      ))}
                    </select>
                  </div>
                  {this.props.predefinedBasePlate.predefinedBasePlateImgPath && (
                    <div className='image-container'>
                      <img src={appConfig.BASE_URL + this.props.predefinedBasePlate.predefinedBasePlateImgPath} alt=''/>
                    </div>
                  )}

                </section>
              )}
            </section>
          )}

          <hr />

          <MaterialSelector
            material={this.props.profileMaterial}
            onMaterialSelect={this.props.onProfileMaterialSelect}
            family={this.props.profileFamily}
            onFamilySelect={this.props.onProfileFamilySelect}
            size={this.props.profileSize}
            onSizeSelect={this.props.onProfileSizeSelect}
          />
        </section>
      </div>
    );
  }

  setProfileType = (e) => {
    switch (e.target.value) {
      case Barrier.types.profile.SQUARE_HOLLOW:
      case Barrier.types.profile.SQUARE_BARS:
      case Barrier.types.profile.ROUND_STEEL_BARS:
      case Barrier.types.profile.PIPE: {
        this.props.onUpdate({
          barrier: {
            profileFamily: e.target.value,
            depth: 10,
            stayWidth: 10
          }
        });

        break;
      }

      case Barrier.types.profile.FLAT_BARS: {
        this.props.onUpdate({
          barrier: {
            profileFamily: e.target.value,
            depth: 3,
            stayWidth: 10
          }
        });

        break;
      }

      case Barrier.types.profile.RECTANGULAR_HOLLOW: {
        this.props.onUpdate({
          barrier: {
            profileFamily: e.target.value,
            depth: 3,
            stayWidth: 10
          }
        });

        break;
      }

      default: {
        throw new Error('Something went wrong!');
      }
    }
  };

}

const mapState = state => ({
  buttonsOptions: state.selectors.application.safetyBarrierButtons.buttonsOptions,

  selectedType: state.selectors.application[APP_TYPES.SAFETY_BARRIER].selectedType,
  selectedSubtype: state.selectors.application[APP_TYPES.SAFETY_BARRIER].selectedSubtype,
  selectedPlate: state.selectors.application[APP_TYPES.SAFETY_BARRIER].selectedPlate,

  profileMaterial: state.selectors.application[APP_TYPES.SAFETY_BARRIER].profile.material,
  profileFamily: state.selectors.application[APP_TYPES.SAFETY_BARRIER].profile.family,
  profileSize: state.selectors.application[APP_TYPES.SAFETY_BARRIER].profile.size,

  cladding: state.selectors.application[APP_TYPES.SAFETY_BARRIER].cladding,

  predefinedBasePlate: state.selectors.application[APP_TYPES.SAFETY_BARRIER].predefinedBasePlate,
  isWaitingPredefinedBP: state.webServices.application.isWaitingPredefinedBP,
  manufacturers: state.webServices.application.manufacturers,
  designations: state.webServices.application.designations
});

const mapDispatch = dispatch => {
  const onSubtype = onSelectSubtype.bind(null, dispatch);
  const onBaseplate = onSelectBaseplate.bind(null, dispatch);

  return {
    onSelectType: item => {
      if (item.config) {
        if (item.config.type) {
          dispatch(setObjectType(item.config.type));
        }
        if (item.config.ground && item.config.ground.padding) {
          dispatch(setGroundOptions(item.config.ground));
        }
        if (item.config.perspectiveCamera) {
          dispatch(setPerspectiveCamera(item.config.perspectiveCamera));
        }
      }

      dispatch(setActiveType(item.id));

      onSubtype(item.subtypes[0]);
    },
    onSelectSubtype: onSubtype,
    onSelectBaseplate: onBaseplate,

    onProfileMaterialSelect: value => dispatch(setProfileMaterial(value)),
    onProfileFamilySelect: value => dispatch(setProfileFamily(value)),
    onProfileSizeSelect: value => dispatch(setProfileSize(value)),
    setCladdingType: value => dispatch(setCladding(value)),

    setPredefinedBasePlate: value => dispatch(setPredefinedBasePlate(value)),
    onSelectManufacturer: value => dispatch(setManufacturer(value)),
    onSelectDesignation: value => dispatch(setDesignation(value))
  };
};

export default connect(mapState, mapDispatch)(SafetyBarrier);

function onSelectSubtype(dispatch, item) {
  dispatch(setActiveSubtype(item.id));

  if (item.config) {
    const { config } = item;

    if (config.panel.dpp) {
      dispatch(setPanelDPP(config.panel.dpp));
    }

    if (config.panel.lyh) {
      dispatch(setPanelLYH(config.panel.lyh));
    }

    if (config.panel.dpl) {
      dispatch(setPanelDPL(config.panel.dpl));
    }

    if (config.panel.position) {
      dispatch(setPanelPosition(config.panel.position));
    }

    // if (config.camera2D) {
    //   dispatch(setAxisPosition(config.camera2D.position));
    // }

    if (config.orientation) {
      dispatch(setAxisOrientation(config.orientation));
    }

    dispatch(disablePanelEdgeDistance(config.panel.disableEdgeDistance));
    dispatch(setPerspectiveCameraType(PerspectiveCameraTypes.zoom_out)); // reset camera type
  }

  onSelectBaseplate(dispatch, item.plate.find((plate) => { return plate.id === item.defaultPlateId; }) || item.plate[0]);
}

function onSelectBaseplate(dispatch, plate) {
  if (plate.config.panel && plate.config.panel.type) {
    dispatch(setPanelType(plate.config.panel.type));
  }

  if (plate.config.screw) {
    if (plate.config.screw.formation === ScrewGroup.formation.FILLED_SQUARE)
      dispatch(setSquareScrews(
        plate.config.screw.count.n, 
        plate.config.screw.count.m, 
        plate.config.screw.count.ignorePositions, 
        false, 
        false,
        plate.config.screw.count.toHorizontalMiddle));
    else if (plate.config.screw.formation === ScrewGroup.formation.TRIANGLE)
      dispatch(setTriangleScrews(plate.config.screw.count.n, 0, 0, false));
    else
      dispatch(setScrewOptions(plate.config.screw));
  }

  dispatch(setActivePlate(plate.id));
  dispatch(setPredefinedBasePlate(false));
  dispatch(getSBPredefinedBPs());
  setTimeout(() => {
    Scene.resetCamera();
  });
}



// WEBPACK FOOTER //
// ./src/views/Application/types/SafetyBarrier/index.js